"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CheckAlt = function CheckAlt(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.375,9.6875 C19.375,7.96875 18.90625,6.328125 18.0468333,4.84375 C17.1875,3.359375 16.0156667,2.1875 14.53125,1.328125 C13.0468333,0.46875 11.40625,0 9.6875,0 C7.92968333,0 6.328125,0.46875 4.84375,1.328125 C3.359375,2.1875 2.14843333,3.359375 1.28906667,4.84375 C0.4296875,6.328125 0,7.96875 0,9.6875 C0,11.4453333 0.4296875,13.0468333 1.28906667,14.53125 C2.14843333,16.0156667 3.359375,17.2265833 4.84375,18.0859167 C6.328125,18.9453333 7.92968333,19.375 9.6875,19.375 C11.40625,19.375 13.0468333,18.9453333 14.53125,18.0859167 C16.0156667,17.2265833 17.1875,16.0156667 18.0468333,14.53125 C18.90625,13.0468333 19.375,11.4453333 19.375,9.6875 Z M8.55466667,14.8046667 C8.4375,14.9609167 8.28125,15 8.125,15 C7.92968333,15 7.77343333,14.9609167 7.69531667,14.8046667 L3.63281667,10.7421667 C3.47656667,10.6640833 3.4375,10.5078333 3.4375,10.3125 C3.4375,10.15625 3.47656667,10 3.63281667,9.88283333 L4.49218333,8.98433333 C4.609375,8.86716667 4.765625,8.78908333 4.921875,8.78908333 C5.078125,8.78908333 5.234375,8.86716667 5.390625,8.98433333 L8.125,11.71875 L13.9843333,5.859375 C14.1015833,5.74218333 14.2578333,5.66406667 14.4140833,5.66406667 C14.5703333,5.66406667 14.7265833,5.74218333 14.8828333,5.859375 L15.7421667,6.75781667 C15.8593333,6.875 15.9375,7.03125 15.9375,7.1875 C15.9375,7.38281667 15.8593333,7.53906667 15.7421667,7.61718333 L8.55466667,14.8046667 Z",
    id: "checkAlt"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#checkAlt"
  }));
};

var _default = CheckAlt;
exports["default"] = _default;
module.exports = exports["default"];